import React, { useMemo } from 'react';
import { TIME_PRESETS } from '../utils/adminMetrics';

function AdminFilters({
  activePreset,
  startDate,
  endDate,
  userFilter,
  typeFilter,
  tmFilter,
  languageFilter,
  availableTMs = [],
  users,
  loading,
  onPresetChange,
  onStartDateChange,
  onEndDateChange,
  onUserChange,
  onTypeChange,
  onTmChange,
  onLanguageChange,
  onRefresh,
}) {
  const languageOptions = useMemo(() => {
    const codes = new Set(
      availableTMs.map((t) => t.targetLanguage).filter(Boolean),
    );
    return Array.from(codes).sort();
  }, [availableTMs]);
  return (
    <div className="admin-filter-bar card">
      <div className="admin-filter-group">
        <span className="admin-filter-label">Time Range</span>
        <div className="admin-range-buttons">
          {TIME_PRESETS.map((preset) => (
            <button
              key={preset.id}
              type="button"
              className={`admin-range-btn ${activePreset === preset.id ? 'active' : ''}`}
              onClick={() => onPresetChange(preset.id)}
              disabled={loading}
            >
              {preset.label}
            </button>
          ))}
        </div>
      </div>

      <div className="admin-filter-group">
        <span className="admin-filter-label">Custom Range</span>
        <div className="admin-date-range">
          <input
            type="date"
            className="admin-date-input"
            value={startDate === 'ALL' ? '' : startDate}
            onChange={(e) => onStartDateChange(e.target.value)}
            disabled={loading || activePreset === 'all'}
          />
          <span className="admin-date-separator">to</span>
          <input
            type="date"
            className="admin-date-input"
            value={endDate === 'ALL' ? '' : endDate}
            onChange={(e) => onEndDateChange(e.target.value)}
            disabled={loading || activePreset === 'all'}
          />
        </div>
      </div>

      <div className="admin-filter-group">
        <span className="admin-filter-label">User Filter</span>
        <select
          className="admin-select"
          value={userFilter}
          onChange={(e) => onUserChange(e.target.value)}
          disabled={loading}
        >
          <option value="ALL">All Users</option>
          {users.map((email) => (
            <option key={email} value={email}>
              {email}
            </option>
          ))}
        </select>
      </div>

      <div className="admin-filter-group">
        <span className="admin-filter-label">Type</span>
        <select
          className="admin-select"
          value={typeFilter}
          onChange={(e) => onTypeChange(e.target.value)}
          disabled={loading}
        >
          <option value="all">All</option>
          <option value="single">Single</option>
          <option value="bulk">Bulk</option>
        </select>
      </div>

      <div className="admin-filter-group">
        <span className="admin-filter-label">Translation Memory</span>
        <select
          className="admin-select"
          value={tmFilter}
          onChange={(e) => onTmChange(e.target.value)}
          disabled={loading}
        >
          <option value="ALL">All TMs</option>
          {availableTMs.map((tm) => (
            <option key={tm.tm_id} value={tm.tm_id}>
              {tm.label}
            </option>
          ))}
        </select>
      </div>

      <div className="admin-filter-group">
        <span className="admin-filter-label">Target Language</span>
        <select
          className="admin-select"
          value={languageFilter}
          onChange={(e) => onLanguageChange(e.target.value)}
          disabled={loading}
        >
          <option value="ALL">All languages</option>
          {languageOptions.map((code) => (
            <option key={code} value={code}>
              {code}
            </option>
          ))}
        </select>
      </div>

      <button
        type="button"
        className="btn btn-secondary admin-refresh-btn"
        onClick={onRefresh}
        disabled={loading}
      >
        {loading ? 'Refreshing…' : 'Refresh'}
      </button>
    </div>
  );
}

export default AdminFilters;
